export function updateAllCategories(state, { categories }) {
  state.all = categories;
}

export function updateCurrentCategory(state, { category }) {
  state.current = category;
}

export function flush(state) {
  state.current = null;
}
